var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.element.value)?_c('Card',{attrs:{"title":_vm.element.label,"loading":_vm.plantRequest.loading,"error":_vm.plantRequest.error,"small":""},on:{"retry":function($event){return _vm.retry($event)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }